"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletClient = void 0;
const __1 = require("../..");
const PermissionManager_1 = require("../../managers/PermissionManager");
const AppMetadataManager_1 = require("../../managers/AppMetadataManager");
const IncomingBeaconMessageInterceptor_1 = require("../../interceptors/IncomingBeaconMessageInterceptor");
const OutgoingBeaconMessageInterceptor_1 = require("../../interceptors/OutgoingBeaconMessageInterceptor");
class WalletClient extends __1.Client {
    constructor(config) {
        super({ name: config.name, storage: new __1.LocalStorage() });
        this.pendingRequests = [];
        this.permissionManager = new PermissionManager_1.PermissionManager(new __1.LocalStorage());
        this.appMetadataManager = new AppMetadataManager_1.AppMetadataManager(new __1.LocalStorage());
    }
    async init() {
        return super.init(false);
    }
    async connect(newMessageCallback) {
        this.handleResponse = async (message, connectionInfo) => {
            if (!this.pendingRequests.some((request) => request.id === message.id)) {
                this.pendingRequests.push(message);
                await IncomingBeaconMessageInterceptor_1.IncomingBeaconMessageInterceptor.intercept({
                    message,
                    connectionInfo,
                    appMetadataManager: this.appMetadataManager,
                    interceptorCallback: newMessageCallback
                });
            }
        };
        return super._connect();
    }
    async respond(message) {
        console.log('responding to message', message);
        const request = this.pendingRequests.find((pendingRequest) => pendingRequest.id === message.id);
        if (!request) {
            throw new Error('No matching request found!');
        }
        this.pendingRequests = this.pendingRequests.filter((pendingRequest) => pendingRequest.id !== message.id);
        await OutgoingBeaconMessageInterceptor_1.OutgoingBeaconMessageInterceptor.intercept({
            beaconId: await this.beaconId,
            request,
            message,
            permissionManager: this.permissionManager,
            appMetadataManager: this.appMetadataManager,
            interceptorCallback: async (response) => {
                await this.respondToMessage(response);
            }
        });
    }
    async getAppMetadataList() {
        return this.appMetadataManager.getAppMetadataList();
    }
    async getAppMetadata(beaconId) {
        return this.appMetadataManager.getAppMetadata(beaconId);
    }
    async removeAppMetadata(beaconId) {
        return this.appMetadataManager.removeAppMetadata(beaconId);
    }
    async removeAllAppMetadata() {
        return this.appMetadataManager.removeAllAppMetadata();
    }
    async getPermissions() {
        return this.permissionManager.getPermissions();
    }
    async getPermission(accountIdentifier) {
        return this.permissionManager.getPermission(accountIdentifier);
    }
    async removePermission(accountIdentifier) {
        return this.permissionManager.removePermission(accountIdentifier);
    }
    async removeAllPermissions() {
        return this.permissionManager.removeAllPermissions();
    }
    async removePeer(id) {
        if ((await this.transport).type === __1.TransportType.P2P) {
            const removePeerResult = (await this.transport).removePeer(id);
            await this.removePermissionsForPeers([id]);
            return removePeerResult;
        }
    }
    async removeAllPeers() {
        if ((await this.transport).type === __1.TransportType.P2P) {
            const peers = await (await this.transport).getPeers();
            const removePeerResult = (await this.transport).removeAllPeers();
            await this.removePermissionsForPeers(peers);
            return removePeerResult;
        }
    }
    async removePermissionsForPeers(peersToRemove) {
        const permissions = await this.permissionManager.getPermissions();
        const peerIdsToRemove = peersToRemove.map((peer) => peer.publicKey);
        // Remove all permissions with origin of the specified peer
        const permissionsToRemove = permissions.filter((permission) => peerIdsToRemove.includes(permission.appMetadata.beaconId));
        const permissionIdentifiersToRemove = permissionsToRemove.map((permissionInfo) => permissionInfo.accountIdentifier);
        await this.permissionManager.removePermissions(permissionIdentifiersToRemove);
    }
    async respondToMessage(message) {
        const serializedMessage = await new __1.Serializer().serialize(message);
        await (await this.transport).send(serializedMessage);
    }
}
exports.WalletClient = WalletClient;
//# sourceMappingURL=WalletClient.js.map